/* Domain */
export const domain = 'https://api-home.myutilitygenius.co.uk';
export const tokenDomain =
  'https://authorisation.myutilitygenius.co.uk';

/* Enquiry Page Title */
export const ENQUIRY_TITLE = 'Select Your Enquiry';

/* Method Page Title */
export const METHOD_SELECTION_TITLE = 'Select Your Search Option';

/* Fuel Type */
export const FUEL_TYPE_GAS = 1;
export const FUEL_TYPE_ELECTRICITY = 2;

/* Query Types */
export const ELECTRICITY_QUERY = 'Electricity';
export const GAS_QUERY = 'Gas';

/* Data Enquiry Methods */
export const POSTCODE = 'Postcode';
export const METER_POINT_ADMINISTRATION_NUMBER = 'MPAN';
export const METER_SERIAL_NUMBER = 'Meter Serial Number';
export const METER_POINT_REFERENCE_NUMBER = 'MPRN';

/* Idle State Timeout */
export const IDLE_STATE_TIMEOUT = 1000 * 60 * 30;

/* Disclaimer text */
export const DISCLAIMER =
  'By using this service, you acknowledge that prior customer consent has been obtained to access property data from the national meter databases';

/* Validations */
/* NOTE: ReGex is taken from official documentation of the GOV.UK: https://assets.publishing.service.gov.uk/government/uploads/system/uploads/attachment_data/file/488478/Bulk_Data_Transfer_-_additional_validation_valid_from_12_November_2015.pdf */
/* UK postcode reGex */
export const UK_POSTCOSR_REGEX =
  '^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})$';

/* Full MPAN reGex  */
export const MPAN_FULL_REGEX = '^[A-Za-z0-9]{21}$';

/* Core MPAN reGex  */
export const MPAN_CORE_REGEX = '^[A-Za-z0-9]{13}$';

/* Core MSN reGex  */
export const MSN_REGEX = '^[A-Za-z0-9]+$';

/* Core MPRN reGex  */
export const MPRN_REGEX = '^[0-9]{6,11}$';

/* The object contain the details of navbar */
export const navbarDetails = {
  navbarTitle: 'Domestic Meter Data Enquiry',
  logoSrc: '/images/navabar/smh-logo.png',
  logoHref: '/query-selection-meter-enquiry',
  logoAlt: 'supplier logo',
  logoDimensions: {
    height: '40px',
    width: '50px',
  },
};

/* The object contain the details for query selection card electricity */
export const querySelectionCardElectricity = {
  cardIcon: 'bi bi-lightning-charge-fill',
  cardIconColor: '#1e21af',
  cardBorder: '1px solid #1e21af',
  cardTitle: ELECTRICITY_QUERY,
  returnedType: FUEL_TYPE_ELECTRICITY,
  cardBackgroundColor: '#fff',
};

/* The object contain the details for query selection card gas */
export const querySelectionCardGas = {
  cardIcon: 'bi bi-fire',
  cardIconColor: '#ffbb2c',
  cardBorder: '1px solid #ffbb2c',
  cardTitle: GAS_QUERY,
  returnedType: FUEL_TYPE_GAS,
  cardBackgroundColor: '#fff',
};

/* The object contain methods for electricity domentic enquiry methods */
export const electricityDomesticEnquiryMethods = [
  {
    cardIcon: 'bi bi-house-door-fill',
    cardIconColor: '#5578ff',
    cardBorder: '1px solid #5578ff',
    cardTitle: POSTCODE,
    returnedType: POSTCODE,
    cardBackgroundColor: '#fff',
  },
  {
    cardIcon: 'bi bi-file-spreadsheet-fill',
    cardIconColor: '#e80368',
    cardBorder: '1px solid #e80368',
    cardTitle: METER_POINT_ADMINISTRATION_NUMBER,
    returnedType: METER_POINT_ADMINISTRATION_NUMBER,
    cardBackgroundColor: '#fff',
  },
  {
    cardIcon: 'bi bi-upc-scan',
    cardIconColor: '#e581ff',
    cardBorder: '1px solid #e581ff',
    cardTitle: METER_SERIAL_NUMBER,
    returnedType: METER_SERIAL_NUMBER,
    cardBackgroundColor: '#fff',
  },
];

/* The object contain methods for gas domentic enquiry methods */
export const gasDomesticEnquiryMethods = [
  {
    cardIcon: 'bi bi-house-door-fill',
    cardIconColor: '#5578ff',
    cardBorder: '1px solid #5578ff',
    cardTitle: POSTCODE,
    returnedType: POSTCODE,
    cardBackgroundColor: '#fff',
  },
  {
    cardIcon: 'bi bi-file-spreadsheet-fill',
    cardIconColor: '#e80368',
    cardBorder: '1px solid #e80368',
    cardTitle: METER_POINT_REFERENCE_NUMBER,
    returnedType: METER_POINT_REFERENCE_NUMBER,
    cardBackgroundColor: '#fff',
  },
];

/* The object is breadcrumb list for data enquiry method selection */
export const breadCrumbsList = {
  dataEnquiryMethodSelection: [
    {
      id: 1,
      breadcrumbName: 'Query Selection',
      Url: '/',
    },
    {
      id: 2,
      breadcrumbName: 'Data Enquiry Method Selection',
    },
  ],
  meterDataEnquiryPanel: [
    {
      id: 1,
      breadcrumbName: 'Query Selection',
      Url: '/',
    },
    {
      id: 2,
      breadcrumbName: 'Data Enquiry Method Selection',
      Url: '/meter-data-enquiry-method-selection',
    },
    {
      id: 3,
      breadcrumbName: 'Data Enquiry Panel',
    },
  ],
};

/* The object contains the details for alert message incase of invalid postcode */
export const postCodeAlertMessage = {
  message: 'Postcode invalid.',
  alertType: 'alert alert-danger',
};

/* The object contains the details for alert message incase of invalid MPAN */
export const mpanAlertMessageInvalidLength = {
  message: 'MPAN invalid.',
  alertType: 'alert alert-danger',
};

/* The object contains the details for alert message incase of nothing is found agaist the given MPAN */
export const mpanAlertMessageNumber = {
  message: 'MPAN not found.',
  alertType: 'alert alert-danger',
};

/* The object contains the details for alert message incase of invalid MSN */
export const msnAlertMessageLength = {
  message: 'Invalid Meter Serial Number.',
  alertType: 'alert alert-danger',
};

/* The object contains the details for alert message incase of nothing found against the MSN */
export const msnAlertMessageNumber = {
  message: 'Meter Serial Number not found.',
  alertType: 'alert alert-danger',
};

/* The object contains the details for alert message incase of invalid MPAN */
export const mprnAlertMessageLength = {
  message: 'MPRN invalid.',
  alertType: 'alert alert-danger',
};

/* The object contains the details for alert message incase of nothing found against the MPAN */
export const mprnAlertMessageNumber = {
  message: 'MPRN not found.',
  alertType: 'alert alert-danger',
};
